export default {
  tip: '提示',
  toDealWith: '前往处理',
  dealWithtips: '请记得在-结算中-上传相关的文件 (公司盖章和签名)',
  loading: '加载数据中...',
  loginTimeout: '登录超时',
  errorMsg: '错误信息',
  systemError: '系统错误',
  pageIsLost: '抱歉，页面找不到了',
  reLogin: '重新登录',
  save: '保存',
  cancel: '取消',
  search: '搜索',
  reset: '重置',
  confirm: '确定',
  opera: '操作 {tips}',
  downloadFile: '文件下载',
  yes: '是',
  no: '否',
  underSubmission: '提交中 ...',
  prevText: '上一页',
  nextText: '下一页',
  keyWord: '关键字',
  all: '全部',
  jan: '1月',
  feb: '2月',
  mar: '3月',
  apr: '4月',
  may: '5月',
  jun: '6月',
  jul: '7月',
  aug: '8月',
  sep: '9月',
  oct: '10月',
  nov: '11月',
  dec: '12月',
  to: '至',
  add: '新增',
  state: '状态',
  showImg: '图片展示',
  close: '关闭',
  followRemark: '跟进备注 Follow up remarks',
  plsSelect: '请选择',
  submit:'提交',
  remark:'注',
  cancelled:'已取消',
  importantHint:'重要提示',
  alreadyExists:'已经存在',
  type: '类别',
  name: '名称',
  size: '大小',
  download: '下载',
  reUpload: '重新上传',
  delete: '删除',
  append: '添加',
  remove: '移除',
  edit: '编辑',
  national: '国籍/地区',
  gender: '性别',
  birthday: '出生日期',
  birthPlace: '出生地址',
  motherTongue: '母语',
  race: '种族',
  tuitionFee: '学费支付',
  idCard: '身份证',
  passport: '护照',
  issueDate: '签发日期',
  expireDate: '到期日期',
  grade: '年级',
  curriculum: 'Curriculum',
  homeTel: '住宅电话',
  mobile: '手机',
  email: '电邮',
  homePlace: '住宅地址',
  dontHave: '没有',
  lastWeek: '最近一周',
  lastMonth: '最近一个月',
  lastThreeMonths: '最近三个月',
  serialNumber: '序号',
  check: '查看',
  active: '激活',
  gmtCreateUser: '创建人',
  gmtCreate: '创建时间',
  refresh: '刷新',
  wechat: '微信',
  cancelAndClose: '取消并关闭',
  role: '角色',
  searchPlaceholder: '请输入搜索内容',
  viewMore: '查看更多',
  noPermission: '当前账号没有权限',
  remarkMessage: '留言备注',
  company: '公司',
  personalAccountCompany: '个人账户公司',
  person: '个人',
  studio: '工作室',
  internationalSchool: '国际学校',
  other: '其他',
  return: '返回',
  submitSuccess: '提交成功',
  submitFail: '提交失败',
  telephone: '电话',
  onlineForm: '线上表单',
  downloadForm: '下载表单',
  resourceManagementItemName1: '澳洲及新西兰',
  resourceManagementTitle: '院校申请指引及申请费',
  noData: "暂无数据~",
  studentsCount: '共{total}名学生',
  applicationCount: '{totalApply}个申请',
  fileUploadTips: '不支持该文件的格式，请重新上传符合格式要求的文件！',
  fileUploadTips2: '文件大小不超过{size}M，请您重新上传符合要求的文件！',
  quickAccess: '快捷入口',
  preview: '预览',
  continue: '继续',
  focusCityTips: '请先选择国家或者省份',
  focusProvinceTips: '请先选择国家',
  dataTotalNumber: '共{totalNumber}条数据',
  gearUpdateReminder:'GEAR更新提醒',
  errorCode: '错误码',
};
